'use client';

import { createContext, useMemo, useState, PropsWithChildren } from 'react';

export type ApplicantFormValues = {
  applicantLastName: string;
  applicantFirstName: string;
  applicantMiddleName: string;
  phone: string;
  agreementTypeIds?: string[];
  consentProcessingPersonalData?: boolean;
  consentInclusionPersonnelReserve?: boolean;
};

type ApplicantFormContextValue = {
  currentStep: number;
  setCurrentStep: (step: number) => void;
  values: ApplicantFormValues | null;
  setValues: (values: ApplicantFormValues) => void;
};

const ApplicantFormContext = createContext<ApplicantFormContextValue>({
  currentStep: 1,
  setCurrentStep: () => {},
  values: null,
  setValues: () => {},
});

export const ApplicantFormProvider = ({ children }: PropsWithChildren) => {
  const [currentStep, setCurrentStep] = useState<number>(1);
  const [formValues, setFormValues] = useState<ApplicantFormValues | null>(null);

  const value = useMemo<ApplicantFormContextValue>(
    () => ({
      currentStep,
      setCurrentStep,
      values: formValues,
      setValues: setFormValues,
    }),
    [currentStep, formValues],
  );

  return <ApplicantFormContext.Provider value={value}>{children}</ApplicantFormContext.Provider>;
};

export { ApplicantFormContext };
